import styles from './header.module.css'

export function Header(){
  return (<div className={styles.Header}>{/* Conteúdo do Header */}</div>)
}